import TextFieldsIcon from "@mui/icons-material/TextFields"; // input
import ViewStreamIcon from "@mui/icons-material/ViewStream"; // one of two
import TableRowsIcon from "@mui/icons-material/TableRows"; // one of three
import GradingIcon from "@mui/icons-material/Grading"; // theory
import EditAttributesIcon from "@mui/icons-material/EditAttributes"; // radio
import PendingActionsIcon from "@mui/icons-material/PendingActions"; // exam
import HdrWeakIcon from "@mui/icons-material/HdrWeak"; // radioinline
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"; // unknown
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"; // matchselect
import FilterIcon from "@mui/icons-material/Filter"; // wordcards
import SmartButtonIcon from "@mui/icons-material/SmartButton"; // openquestion
import SortByAlphaIcon from "@mui/icons-material/SortByAlpha"; // order
import ExtensionIcon from "@mui/icons-material/Extension"; // memo
import CompareArrowsIcon from "@mui/icons-material/CompareArrows"; // match
// multichoice — a list with a tick, the nearest MUI 5.8 equivalent of the v3
// side's lucide `ListChecks`. NOT `Checklist`: that icon only ships from
// @mui/icons-material 5.11, and this app is pinned to 5.8.4.
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";

import Tooltip from "@mui/material/Tooltip";

export default function assignmentType({ type, fullType }) {
  const icon = (type) => {
    switch (type) {
      case "oneoftwo":
        return <ViewStreamIcon />;
      case "input":
        return <TextFieldsIcon />;
      case "theory":
        return <GradingIcon />;
      case "exam":
        return <PendingActionsIcon />;
      case "radio":
        return <EditAttributesIcon />;
      case "radioinline":
        return <HdrWeakIcon />;
      case "matchselect":
        return <ArrowDropDownIcon />;
      case "oneofthree":
        return <TableRowsIcon />;
      case "wordcards":
        return <FilterIcon />;
      case "openquestion":
        return <SmartButtonIcon />;
      case "memo":
        return <ExtensionIcon />;
      case "match":
        // Two columns joined into pairs — the ↔ reads as "connect these",
        // distinct from Memo's puzzle piece over the same word pack.
        return <CompareArrowsIcon />;
      case "multichoice":
        return <PlaylistAddCheckIcon />;
      case "order":
        return <SortByAlphaIcon />;
      default:
        return <HelpOutlineIcon />;
    }
  };

  return <Tooltip title={fullType}>{icon(type)}</Tooltip>;
}
